const bar = (xAxis, data) => {
  const defaultConfig = {
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    dataZoom: [
      {
        type: 'inside',
        startValue: 0,
        endValue: 9
      },
      {
        type: 'slider',
        startValue: 0,
        endValue: 9
      }
    ],
    xAxis: [
      {
        type: 'category',
        data: xAxis,
        axisLabel: {
          interval: 0,
          rotate: 60
        },
        axisTick: {
          alignWithLabel: true
        }
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: [
      {
        type: 'bar',
        data,
        label: {
          show: true,
          position: 'top'
        },
      }
    ]
  }

  const opt = Object.assign({}, defaultConfig)
  return opt
}
const mixedLineAndBar = ( legend, xAxis, yAxis, barData, lineData ) => {
  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    dataZoom: [
      {
        type: 'inside',
        startValue: 0,
        endValue: 9
      },
      {
        type: 'slider',
        startValue: 0,
        endValue: 9
      }
    ],
    legend: {
      data: legend
    },
    xAxis: [
      {
        type: 'category',
        data: xAxis,
         axisLabel: {
          interval: 0,
          rotate: 60
        },
        axisTick: {
          alignWithLabel: true
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: legend[0].name,
        min: yAxis[0].min,
        max: yAxis[0].max,
        interval: yAxis[0].interval,
        axisLabel: {
          formatter: '{value}'
        }
      },
      {
        type: 'value',
        name: legend[1].name,
        min: yAxis[1].min,
        max: yAxis[1].max,
        interval: yAxis[1].interval,
        axisLabel: {
          formatter: '{value}'
        }
      }
    ],
    series: [
      {
        name: legend[0].name,
        type: 'bar',
        label: {
          show: true,
          position: 'top'
        },
        tooltip: {
          valueFormatter: function (value) {
            return value + ' ' + legend[0].tooltip;
          }
        },
        data: barData
      },
      {
        name: legend[1].name,
        type: 'line',
        yAxisIndex: 1,
        label: {
          show: true,
          position: 'top'
        },
        tooltip: {
          valueFormatter: function (value) {
            return value + ' ' + legend[1].tooltip;
          }
        },
        data: lineData
      }
    ]
  };
  return option;
}

export default {
  bar,
  mixedLineAndBar
}